import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../shared/modals/modal.component';
import CustomReportsDataGrid from '../../shared/customReports/customReportsDataGrid.component';
import CustomReportsSetDataGrid from '../../shared/customReports/customReportsSetDataGrid.component';
import { CustomReportTypes } from '../../shared/customReports/constants';
import { customReportDataPropTypes } from '../../shared/customReports/propTypes';
import { requiredWhenPresent } from '../../shared/propTypes';

class CustomReportModal extends PureComponent {
  static propTypes = {
    hideModal: PropTypes.func.isRequired,
    customReportData: requiredWhenPresent(['isVisible'], customReportDataPropTypes),
    isVisible: PropTypes.bool,
    formData: PropTypes.shape({
      serverSide: PropTypes.bool,
      query: PropTypes.shape({
        value: PropTypes.string,
      }),
    }).isRequired,
    queryParams: PropTypes.objectOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
    ])).isRequired,
  };

  render() {
    const { customReportData, formData, queryParams, hideModal, isVisible } = this.props;
    return (
      <Modal
        className="custom-report-modal"
        title={customReportData && customReportData.name}
        closeAction={hideModal}
        submitText="Close"
        submitAction={hideModal}
        isVisible={isVisible}
      >
        <div>
          {
            customReportData && customReportData.customReportType === CustomReportTypes.REPORT
              ? (
                <CustomReportsDataGrid
                  columns={customReportData.columns}
                  rows={customReportData.rows}
                  types={customReportData.types}
                  serverSide={formData.serverSide.value}
                  sql={formData.query.value}
                  queryParams={queryParams}
                  disableLocalStorage
                />
              )
              : null
          }

          {
            customReportData && customReportData.customReportType !== CustomReportTypes.REPORT
              ? (
                <CustomReportsSetDataGrid
                  reports={customReportData.reports.map(report => ({ ...report, pillName: report.name }))}
                  queryParams={queryParams}
                  disableLocalStorage
                />
              )
              : null
          }
        </div>
      </Modal>
    );
  }
}

export default CustomReportModal;
